var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h2", [_vm._v(" Preview Data ")]),
      _c(
        "button",
        { staticClass: "btn btnAccent", on: { click: _vm.goBackToImport } },
        [_vm._v("Go Back")]
      ),
      _c(
        "button",
        {
          staticClass: "btn btnAccent ms-3",
          on: { click: _vm.saveMenuChanges },
        },
        [
          _vm._v(
            _vm._s(
              _vm.activeHeaderName === ""
                ? "Import All Data"
                : 'Import "' + _vm.activeHeaderName + '"'
            )
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "d-flex flex-wrap gap-2 my-3" },
        _vm._l(_vm.jobData.result.menu_items, function (header) {
          return _c(
            "button",
            {
              key: header.ItemHeader + "-filter",
              class: [
                "btn",
                "btn-sm",
                "rounded-pill",
                _vm.isHeaderActive(header.ItemHeader)
                  ? "btn-dark text-white"
                  : "btn-outline-secondary",
              ],
              on: {
                click: function ($event) {
                  return _vm.toggleHeaderFilter(header.ItemHeader)
                },
              },
            },
            [_vm._v(" " + _vm._s(header.ItemHeader) + " ")]
          )
        }),
        0
      ),
      _c("div", { staticClass: "mb-3" }, [
        _c("h5", [_vm._v("Item Search")]),
        _c(
          "div",
          {
            staticClass: "input-group mb-3",
            staticStyle: { "max-width": "300px" },
          },
          [
            _vm._m(0),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchQuery,
                  expression: "searchQuery",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search by name of item" },
              domProps: { value: _vm.searchQuery },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchQuery = $event.target.value
                },
              },
            }),
          ]
        ),
      ]),
      _vm._l(_vm.enrichHeaders, function (header, headerIndex) {
        return _c(
          "div",
          { key: "header_" + headerIndex, staticClass: "header-group" },
          [
            _c(
              "label",
              {
                staticClass:
                  "h3 header-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2",
                attrs: { for: "for_" + header },
              },
              [
                _vm._v(_vm._s(header.ItemHeader) + " "),
                _c(
                  "button",
                  {
                    staticClass: "tooltip-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.alertInfo("header")
                      },
                    },
                  },
                  [_c("span", { staticClass: "question-mark" }, [_vm._v("?")])]
                ),
              ]
            ),
            header.modifiers.length > 0
              ? _c(
                  "div",
                  { staticClass: "row mt-4" },
                  _vm._l(header.modifiers, function (modifier, modIndex) {
                    return _c(
                      "div",
                      {
                        key: "modifier_" + modIndex,
                        staticClass: "card m-3",
                        staticStyle: { width: "18rem" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c("h5", { staticClass: "card-title mt-1 mb-2" }, [
                              _vm._v("Modifier "),
                              _c(
                                "button",
                                {
                                  staticClass: "tooltip-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.alertInfo("modifier")
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "question-mark" }, [
                                    _vm._v("?"),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._l(
                              modifier.answer_list,
                              function (answer, index) {
                                return _c(
                                  "div",
                                  { key: "answer" + index, staticClass: "m-2" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "card-text text-muted fs-6",
                                      },
                                      [_vm._v(_vm._s(answer))]
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            header.items.length > 0
              ? _c(
                  "div",
                  { staticClass: "row mt-4" },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "h5 subheader-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2",
                        attrs: { for: "for_" + header },
                      },
                      [
                        _vm._v("Items "),
                        _c(
                          "button",
                          {
                            staticClass: "tooltip-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.alertInfo("item")
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "question-mark" }, [
                              _vm._v("?"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._l(header.items, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: "item_" + index,
                          staticClass: "card m-3",
                          staticStyle: { width: "18rem" },
                        },
                        [
                          _c("div", { staticClass: "card-body" }, [
                            _c("h5", { staticClass: "card-title mt-1" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _c(
                              "p",
                              { staticClass: "card-text text-muted fs-6" },
                              [_vm._v("$" + _vm._s(item.cost))]
                            ),
                            _c("p", { staticClass: "card-text fixedTextBox" }, [
                              _vm._v(
                                _vm._s(
                                  item.description == ""
                                    ? "N/A"
                                    : item.description
                                )
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "ph-bold ph-magnifying-glass" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }